import { render, staticRenderFns } from "./CustomerKPI.vue?vue&type=template&id=396ba0a3&scoped=true"
import script from "./CustomerKPI.vue?vue&type=script&lang=js"
export * from "./CustomerKPI.vue?vue&type=script&lang=js"
import style0 from "./CustomerKPI.vue?vue&type=style&index=0&id=396ba0a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ba0a3",
  null
  
)

export default component.exports